import styled from 'styled-components';

const ButtonContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: space-between;
`;

export { ButtonContainer };
